import jwt from 'jsonwebtoken';

export default function jwtChecker(){    
    const sessionJwt = sessionStorage.getItem("token")

    if (sessionJwt !== null){

        try {
            var decoded = jwt.verify(sessionJwt, process.env.REACT_APP_JWT_SALT)           
            return decoded
        } catch(err) {
            sessionStorage.clear()
            //this.props.histroy.push("/")
            // window.location("/");
            return false;
        }

    }

}